import { NgModule } from '@angular/core';

import { UiNewLayoutIconText } from './components/icon-text/icon-text.component';
import { UiNewLayoutIconTextValue } from './components/icon-text-value/icon-text-value.component';
import { UiNewSeparatorComponent } from './components/separator/separator.component';

const layouts = [UiNewLayoutIconText, UiNewLayoutIconTextValue, UiNewSeparatorComponent];

export { UiNewLayoutIconTextValue } from './components/icon-text-value/icon-text-value.component';
@NgModule({
	imports: layouts,
	exports: layouts,
})
export class UiNewLayouts {}
